/* Pikemla Vitals replacement — small storefront enhancements (vanilla JS) */
(function () {
  'use strict';

  /* ---------- Back to top ---------- */
  var backToTop = document.querySelector('[data-pk-back-to-top]');
  if (backToTop) {
    var onScroll = function () {
      if (window.scrollY > 600) {
        backToTop.hidden = false;
        backToTop.classList.add('is-visible');
      } else {
        backToTop.classList.remove('is-visible');
        backToTop.hidden = true;
      }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    backToTop.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  /* ---------- External links open in new tab ---------- */
  document.querySelectorAll('a[href^="http"]').forEach(function (a) {
    try {
      var url = new URL(a.href);
      if (url.hostname !== window.location.hostname) {
        a.setAttribute('target', '_blank');
        a.setAttribute('rel', 'noopener');
      }
    } catch (e) { /* ignore malformed urls */ }
  });

  /* ---------- Tab-switch message + cart count in tab title ---------- */
  var baseTitle = document.title.replace(/^\(\d+\)\s*/, '');
  var awayTitle = 'Still thinking? Your picks are waiting · Pikemla';
  var cartCount = 0;

  function paintTitle() {
    if (document.hidden) {
      document.title = awayTitle;
    } else {
      document.title = cartCount > 0 ? '(' + cartCount + ') ' + baseTitle : baseTitle;
    }
  }

  function refreshCartCount() {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        cartCount = cart.item_count || 0;
        paintTitle();
      })
      .catch(function () { /* cart unavailable */ });
  }

  document.addEventListener('visibilitychange', paintTitle);
  document.addEventListener('DOMContentLoaded', refreshCartCount);
  // Re-check after any cart form submission
  document.addEventListener('submit', function (e) {
    if (e.target && e.target.action && e.target.action.indexOf('/cart') !== -1) {
      setTimeout(refreshCartCount, 800);
    }
  });
})();
